import React, { memo } from 'react';

const QuoteMoveSpecialistLoadingState: React.FC = () => {
  return (
    <>
      {/*-- mobile and tablet --*/}
      <div className="flex items-center justify-between px-10 py-6 bg-loading/background-1 xl:hidden">
        <div className="flex items-center justify-start gap-x-4">
          <div className="w-16 h-16 rounded-full bg-loading/background-2" />
          <div>
            <div className="w-40 h-6 rounded-lg bg-loading/background-2" />
            <div className="w w-48 h-8 rounded-lg bg-loading/background-2" />
          </div>
        </div>
        <div className="w-12 h-12 rounded-full bg-loading/background-2" />
      </div>
      {/*-- desktop --*/}
      <div className="hidden xl:bg-loading/background-1 xl:w-full xl:flex xl:flex-col xl:items-center xl:justify-center xl:p-10 xl:gap-y-10">
        <div className="w-full space-y-4 px-10">
          <div className="space-y-2 flex flex-col items-center">
            <div className="w-4/5 h-8 rounded-xl bg-loading/background-2" />
            <div className="w-full h-8 rounded-xl bg-loading/background-2" />
            <div className="w-1/2 h-8 rounded-xl bg-loading/background-2" />
          </div>
        </div>
        <div className="w-4/5 h-6 rounded-lg bg-loading/background-2" />
        <div className="w-full">
          <div className="px-[72px]">
            <div className="w-full h-64 rounded-xl bg-loading/background-2" />
          </div>
        </div>
        <div className="w-full space-y-10">
          {[
            'loading-social-icon-one',
            'loading-social-icon-two',
            'loading-social-icon-three',
            'loading-social-icon-four',
          ].map((loadingSocialId: string) => (
            <div key={loadingSocialId} className="w-full flex items-center justify-between">
              <div className="flex items-center justify-start gap-x-4">
                <div className="w-10 h-10 rounded-full bg-loading/background-2" />
                <div className="w-36 h-6 rounded-lg bg-loading/background-2" />
              </div>
              <div className="w-6 h-6 rounded-lg bg-loading/background-2"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default memo(QuoteMoveSpecialistLoadingState);
